export const fakeEuroConvRate = {
  data: {
    id: "euro",
    symbol: "EUR",
    currencySymbol: "€",
    type: "fiat",
    rateUsd: "1.0826471155032902",
  },
  timestamp: 1675617776991,
};
